/**
 * External API Endpoints Configuration
 *
 * This file contains all external API endpoints used in the application.
 * These are third-party services that are not part of our backend API.
 */

export const EXTERNAL_APIS = {
  /**
   * CNN Fear & Greed Index API
   * Provides current market sentiment data (0-100 scale)
   * Updates: Typically daily during market hours
   */
  FEAR_GREED_INDEX: 'https://production.dataviz.cnn.io/index/fearandgreed/graphdata',

  /**
   * TradingView Ticker Widget Script
   * Embeddable market ticker tape widget
   */
  TRADINGVIEW_WIDGET: 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js',
} as const;
